const JIRA_ISSUE_KEY_PATTERN = /^[A-Z][A-Z0-9]*-\d+$/;

const normalizeDecision = (decision) => String(decision || '').toLowerCase();

export const isApproved = (decision) => normalizeDecision(decision).includes('godkänd');

export const isApprovedWithReservation = (decision) =>
  normalizeDecision(decision).includes('godkänd med förbehåll');

export const isRejected = (decision) => normalizeDecision(decision).includes('underkänd');

/** 'Ingen avvikelse' never touches the AO, so it has nothing to link a deviation to. */
export const supportsDeviationLink = (decision) =>
  isApproved(decision) || isRejected(decision);

export const normalizeReservationTicketKey = (value) =>
  String(value || '').trim().toUpperCase();

export const isValidReservationTicketKey = (value) =>
  JIRA_ISSUE_KEY_PATTERN.test(normalizeReservationTicketKey(value));

/**
 * Every approved decision links the AO to the deviation it rests on, so the key is
 * needed until that link exists. 'Godkänd med förbehåll' also writes the justification
 * line with a due date, so either step still pending keeps the field required on a retry.
 */
export const requiresReservationTicketKey = (row = {}) => {
  if (!isApproved(row.jiraDecision)) {
    return false;
  }
  if (!row.decisionReservationLinkCreated) {
    return true;
  }
  return isApprovedWithReservation(row.jiraDecision) && !row.decisionReservationAdded;
};

/** The field itself follows the decision, not the retry state — a handled row is read-only. */
export const showsReservationTicketKey = (row = {}) =>
  supportsDeviationLink(row.jiraDecision) && !row.decisionProcessed;
